import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#tenants",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode(" Reset password ")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createTextVNode("Reset the password for ")),
          _createElementVNode("strong", null, _toDisplayString($data.user?.email), 1 /* TEXT */),
          _cache[3] || (_cache[3] = _createTextVNode("? Their current password will stop working."))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "A temporary password will be sent to their sign-in email using the branded design.", -1 /* HOISTED */)),
        _createVNode(_component_Checkbox, {
          modelValue: $data.use_aws_email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.use_aws_email) = $event)),
          "font-size": "1.4rem"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Use the AWS email style instead")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, { onClick: $options.close }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Cancel")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("Reset password")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}